import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import {
  Box,
  Grid,
  Typography,
  Link as MuiLink,
  useMediaQuery,
  useTheme,
} from '@material-ui/core';
import { Link as RouterLink } from 'react-router-dom';
import logo from 'assets/logos/logo_white.png';

import PDF1 from '../../assets/pdf/CGAC_P4F_2025.pdf';
import PDF2 from '../../assets/pdf/CGAP_P4F_2025.pdf';
// import PDF3 from '../../assets/pdf/Codice_Comportamento_P4F_261022.pdf'; // rimosso perché non usato
// import PDF4 from '../../assets/pdf/itce_001292_genericcertificate_final.pdf'; // rimosso perché non usato
import PDF5 from '../../assets/pdf/P4F_MODELLO 231_PARTE GENERALE_v.01.12.2023.pdf';
import { useTranslation } from 'react-i18next';

const useStyles = makeStyles((theme) => ({
  footer: {
    backgroundColor: '#415364',
    color: theme.palette.common.white,
    padding: theme.spacing(6, 1),
    fontSize: '1.6rem',
    lineHeight: '1rem',
    fontWeight: 400,
    width: '100%',
    maxWidth: '100vw',
  },
  container: {
    maxWidth: '960px',
    margin: '0 auto',
    padding: 5,
  },
  logo: {
    maxWidth: '80%',
    height: 'auto',
    display: 'block',
  },
  text: {
    display: 'block',
    marginBottom: theme.spacing(1),
    color: theme.palette.common.white,
    fontSize: '0.8rem',
    lineHeight: '1.5',
    fontFamily: 'Trade Gothic LT STD',
    fontWeight: 400,
    whiteSpace: 'nowrap',
  },
  link: {
    whiteSpace: 'nowrap',
    display: 'block',
    marginBottom: theme.spacing(1),
    color: theme.palette.common.white,
    fontSize: '0.9rem',
    lineHeight: '100%',
    fontWeight: 400,
    fontFamily: 'Trade Gothic LT STD',
    textDecoration: 'underline',
    '&:hover': {
      textDecoration: 'underline',
    },
  },
}));

export default function Footer() {
  const classes = useStyles();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const {
    i18n: { language },
  } = useTranslation();

  const whistleblowingPolicyEnLink = "https://power4future.segnalazioni.net/en/pages/policy";
  const whistleBlowingEnLink = "https://power4future.segnalazioni.net/en/";
  const privacyPolicyEnLink = "https://power4future.segnalazioni.net/en/pages/privacy";
  const cookiePolicyEnLink = "https://power4future.segnalazioni.net/en/pages/cookie-policy"

  const whistleblowingPolicyItLink = "https://power4future.segnalazioni.net/pages/policy";
  const whistleBlowingItLink = "https://power4future.segnalazioni.net/";
  const privacyPolicyItLink = "https://power4future.segnalazioni.net/pages/privacy";
  const cookiePolicyItLink = "https://power4future.segnalazioni.net/pages/cookie-policy"

  let whistleblowingPolicyLink = null;
  let whistleBlowingLink = null;
  let privacyPolicyLink = null;
  let cookiePolicyLink = null;

  switch (language) {
    case 'en':
      whistleblowingPolicyLink = whistleblowingPolicyEnLink;
      whistleBlowingLink = whistleBlowingEnLink;
      privacyPolicyLink = privacyPolicyEnLink;
      cookiePolicyLink = cookiePolicyEnLink;
      break;
    case 'it':
      whistleblowingPolicyLink = whistleblowingPolicyItLink;
      whistleBlowingLink = whistleBlowingItLink;
      privacyPolicyLink = privacyPolicyItLink;
      cookiePolicyLink = cookiePolicyItLink;
      break;
    default:
      whistleblowingPolicyLink = whistleblowingPolicyItLink;
      whistleBlowingLink = whistleBlowingItLink;
      privacyPolicyLink = privacyPolicyItLink;
      cookiePolicyLink = cookiePolicyItLink;
  }

  return (
    <Box component="footer" className={classes.footer}>
      <Grid container justifyContent="center">
        <Grid item xs={10}>
          <Box className={classes.container}>
            <Grid container spacing={7}>
              <Grid item xs={12} sm={3}>
                <img
                  src={logo}
                  alt="Logo placeholder"
                  className={classes.logo}
                />
              </Grid>

              <Grid item xs={6} sm={3}>
                <Typography className={classes.text}>
                  POWER4FUTURE © 2024
                </Typography>
                <Typography className={classes.text}>
                  Strada Provinciale 276, Località Volla
                </Typography>
                <Typography className={classes.text}>
                  03030 - Piedimonte San Germano (FR), <br /> Italy
                </Typography>
                <Typography className={classes.text}>
                  C.F. 03941241204
                </Typography>
                <Typography className={classes.text}>
                  P.IVA 03941241204
                </Typography>
              </Grid>

              <Grid item xs={6} sm={2}>
                <MuiLink
                  href="mailto:info@power4future.it"
                  className={classes.link}
                >
                  info@power4future.it
                </MuiLink>
                <MuiLink
                  href="mailto:sales@power4future.it"
                  className={classes.link}
                >
                  sales@power4future.it
                </MuiLink>
                <MuiLink href="tel:+390776401119" className={classes.link}>
                  +39 0776 4011 19
                </MuiLink>
                <MuiLink
                  href="https://www.linkedin.com/company/power4future/"
                  target="_blank"
                  rel="noopener"
                  className={classes.link}
                >
                  linkedin/power4future
                </MuiLink>
              </Grid>

              {!isMobile && (
                <>
                  <Grid item xs={6} sm={2}>
                    <MuiLink
                      component={RouterLink}
                      to="/"
                      className={classes.link}
                    >
                      Homepage
                    </MuiLink>
                    <MuiLink
                      component={RouterLink}
                      to="/who-we-are"
                      className={classes.link}
                    >
                      Chi siamo
                    </MuiLink>
                    <MuiLink
                      component={RouterLink}
                      to="/applications"
                      className={classes.link}
                    >
                      Applicazioni
                    </MuiLink>
                    <MuiLink
                      component={RouterLink}
                      to="/products"
                      className={classes.link}
                    >
                      Prodotti
                    </MuiLink>
                    <MuiLink
                      component={RouterLink}
                      to="/news"
                      className={classes.link}
                    >
                      News
                    </MuiLink>
                    <MuiLink
                      component={RouterLink}
                      to="/contacts"
                      className={classes.link}
                    >
                      Contatti
                    </MuiLink>
                  </Grid>
                  <Grid item xs={6} sm={2}>
                    <MuiLink
                      target="_blank"
                      href={whistleBlowingLink}
                      className={classes.link}
                    >
                      Whistleblowing
                    </MuiLink>
                    <MuiLink
                      target="_blank"
                      href={whistleblowingPolicyLink}
                      className={classes.link}
                    >
                      Whistleblowing Policy
                    </MuiLink>
                    <MuiLink
                      target="_blank"
                      href={privacyPolicyLink}
                      className={classes.link}
                    >
                      Privacy Policy
                    </MuiLink>
                    <MuiLink
                      target="_blank"
                      href={cookiePolicyLink}
                      className={classes.link}
                    >
                      Cookie Policy
                    </MuiLink>
                    <MuiLink
                      href={PDF5}
                      target="_blank"
                      rel="noopener"
                      className={classes.link}
                    >
                      D.lgs. 231
                    </MuiLink>
                    <MuiLink
                      href={PDF1}
                      target="_blank"
                      rel="noopener"
                      className={classes.link}
                    >
                      CGAQ
                    </MuiLink>
                    <MuiLink
                      href={PDF2}
                      target="_blank"
                      rel="noopener"
                      className={classes.link}
                    >
                      CGAP
                    </MuiLink>
                  </Grid>
                </>
              )}
            </Grid>
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
}
